
export default {

  type: {
    message : "Invalid gender",
    fn      : (input)=> ["F", "M"].includes(input)
  },

}
